import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Alert, Button } from 'reactstrap';
import LoggedContext from '../BusinessObjects/LoggedContext'
import cubeApiClient from '../BusinessObjects/cubeApiService';
import ResourceField from '../Models/ResourceField';

import EsaedroLookup from './EsaedroLookup';
import EsaedroResourceFilter from '../Models/EsaedroResourceFilter';
import { themeCol3, themeCol4, themeCol9, themeGroup, themeSpinner, themeFormInput, themeBackButton, themeUpdateButton, themeCol6, themeCol6Right, themeSaveButton } from '../Utils/EsaedroTheme';
import { StickyContainer, Sticky } from 'react-sticky';

import EsaedroPDF from './EsaedroPDF'
import EsaedroResourceAttachment from '../Models/EsaedroResourceAttachment';
import EsaedroAttachmentsController from './EsaedroAttachmentsController';
import { threadId } from 'worker_threads';
import EsaedroAttachmentLoader from './EsaedroAttachmentLoader';
import EsaedroAttachment from './EsaedroAttachment';
import EsaedroJSONComponent from './EsaedroJSONComponent';

export interface EsaedroObjectEditProps {
  myObjType: string
  myObjUrl: string
  myObj?: any
  myObjResourceID?: number,
  isNew: boolean
  filters: string
  fixedFields?: EsaedroResourceFilter[]
  onReturn?(ackMessage?: string): void
  onCustomHandleChange?( objChanged: any, fieldName: string): void
  onCustomRenderField?( editedObject: any, field: ResourceField): void
}

interface EsaedroObjectEditState {
  myObject: any; 
  myObjectFields: ResourceField[];
  myObjectFilters: EsaedroResourceFilter[];
  hasFields: boolean;
  hasGroups: boolean;
  myObjectGroups: any[];
  errorMessage: string;
  loading: boolean;
  updating: boolean;
  addAttachments: boolean;
  showAttachments: boolean;
}

export default class EsaedroObjectEdit extends Component<EsaedroObjectEditProps, EsaedroObjectEditState> {

  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>

  disableUpdateBtn: boolean = false
  
  // Mi creo le mappe per gestire le lookup come variabili fuori dallo stato
  // Nomi dei campi delle lookup che hanno campi da controllare
  lookupFieldsWithFieldsToCheck : string[] = []
  // Campi da controllare per ogni lookup (nome campo in chiave)
  lookupFieldsToCheck: Map<string, any[]> = new Map()
  // Key incrementali delle lookup (nome campo in chiave) - Se incrementate triggerano il render sulla relativa lookup
  lookupKeys: Map<string,number> = new Map()

  constructor(props: any) {
    super(props);

    this.state = { 
      myObject: {},
      myObjectFields: [],
      myObjectFilters: [],
      hasFields: false,
      hasGroups: false,
      myObjectGroups: [],
      errorMessage:'',
      loading: false,
      updating: false,
      addAttachments: false,
      showAttachments: false
    };
  }

  componentDidMount() {

    this.setState({loading: true})

    if (this.props.filters)
    {
      let filtersList = this.props.filters.split('&')

      filtersList.map(element => {
        var v =element.split('=');
        this.state.myObjectFilters.push(new EsaedroResourceFilter(v[0],v[1],"="));
      });
    }

    if (!this.props.isNew && this.props.myObj!=undefined) this.setState({myObject: this.props.myObj})
    
    if(this.context.userProfile == undefined) 
    {
        this.setState({errorMessage:'utente non definito'});
        return;
    }

    if(this.context.userProfile.customer_ID == 0) 
    {
        this.setState({errorMessage:'azienda non selezionata'});
        return;
    }

    const service = new cubeApiClient();
    
    const t = this.context.tokenAPI;

    // TODO fare funzione statica (in classe Utils?) che controlla se un oggetto è filtrabile dato un filtro o Array di filtri e poi filtrare eventualmente la richiesta

    // TODO check che se uno fa new e ci sono campi non visible non nullabili e senza default lui non potrà mai inserire il campo
    const requrl = this.props.isNew? 'api/sys/ResourcesFields?RecordSelection=' + encodeURIComponent("ResourceName='" + this.props.myObjType + "'") : 'api/sys/ResourcesFields?RecordSelection=' + encodeURIComponent("ResourceName='" + this.props.myObjType + "' and Is_Visible=1")
   
    //const groupsURL = 'api/sys/ResourcesFieldsGroups?RecordSelection=' + encodeURIComponent("ResourceName='" + this.props.myObjType + "'") 

    service
        .getItems(requrl,t)
        .then((data: any) => {
            // Chiedo di nuovo i campi
            if (data)
            {
              // Capire se mettere il resto qui dentro e se fare delle richieste parallele
              /*service
                .getItems(groupsURL,t)
                .then((groupsData: any) => {
                  this.setState({
                    myObjectGroups:groupsData,
                    hasGroups: true
                  })
                },
                (error: any) => {
                    this.setState({ 
                      myObjectFields:[],
                      errorMessage: error,
                      loading: false
                    });
                });*/

              // Devo fare due volte l'aggiornamento dello stato, perchè l'EmptyObject ha bisogno dei field aggiornati
              if (this.props.isNew) {

                // Creo le chiavi per le varie lookup
                data.forEach ((field :ResourceField) => {
                  if (field.LookupName|| field.LookupValues) this.lookupKeys.set(field.FieldName, 0)
                })
                // Aggiorno lo stato due volte
                this.setState({ 
                  hasFields: true,
                  myObjectFields: data
                })
                let newObject = this.createEmptyObject()
                this.setState({ 
                  myObject: newObject,
                  loading: false
                })
              }
              else {
                // Creo le chiavi per le varie lookup
                data.forEach ((field :ResourceField) => {
                  if (field.LookupName|| field.LookupValues) this.lookupKeys.set(field.FieldName, 0)
                })
                // Aggiorno lo stato
                this.setState({ 
                  hasFields: true,
                  myObjectFields: data,
                  loading: false
                })  
              }
            }
            else {
              this.setState({
                errorMessage:"Errore nello scaricare i campi",
                loading: false
              })
            }
        },
        (error: any) => {
            this.setState({ 
              myObjectFields:[],
              errorMessage: error,
              loading: false
            });
        });
  }

  // Chiama il servizio di update
  updateObject = (event: any) => {

    const service = new cubeApiClient();
    event.preventDefault();

    const objectToEdit = this.state.myObject;

    this.setState({updating:true})

    service
      .updateObject(objectToEdit, this.props.myObjUrl, this.context.tokenAPI)
      .then(() => {
        this.setState({ 
          // Gestire il successo?
          errorMessage:'',
          updating: false
        });
        //alert("sto per tornare alla lista!")
        if (this.props.onReturn!=undefined) {
          let successMsg = "Operazione avvenuta con successo!"
          this.props.onReturn(successMsg)
        }
    },
    (error: any) => {
        // Rimane qui. Problema col timestamp?
        let stringError = "Errore nel salvataggio:"+JSON.stringify(error)
        //alert(stringError)
        this.setState({ 
          errorMessage: stringError,
          updating: false 
        });
    });
  }

  // Gestisce i cambiamenti in input e li salva nello stato dell'object, innescando il rendering
  handleChange = (event: any) => {

    // Controllo come prima cosa che non si tratti di un customEvent
    if (event.type == "DeleteFile") {
      
      value = undefined
      var name = event.detail;

      let tempObj = this.state.myObject;
      tempObj[name] = value;

      // Inserisco qui l'eventuale callback
      if (this.props.onCustomHandleChange) {
        this.props.onCustomHandleChange(tempObj, name)
      }
      this.setState({
        myObject: tempObj
      });
    }

    else if (event.type == "JSONObjectChanged") {
      
      value = event.detail["value"]
      var name = event.detail["name"]
      let tempObj = this.state.myObject;
      tempObj[name] = value;

      // Inserisco qui l'eventuale callback
      if (this.props.onCustomHandleChange) {
        this.props.onCustomHandleChange(tempObj, name)
      }
      this.setState({
        myObject: tempObj
      });
    }

    else {
      const target = event.target;
      
      var value = undefined
      
      
      // Se è un file mi comporto diversamente
      if (target.type == "file") {
        var reader = new FileReader()
        reader.onload = () => {
          let imgUrl = reader.result
          value = imgUrl
          var name = target.name;

          let tempObj = this.state.myObject;
          tempObj[name] = value;

          // Inserisco qui l'eventuale callback
          if (this.props.onCustomHandleChange) {
            this.props.onCustomHandleChange(tempObj, name)
          }
          this.setState({
            myObject: tempObj
          });
        }
        reader.readAsDataURL(event.target.files[0])
      }

      else {

        if (target.type == 'checkbox') {
          value = target.checked
        }

        else value = target.value

        var name = target.name;
      
        let tempObj = this.state.myObject;
        tempObj[name] = value;

        // Inserisco qui l'eventuale callback
        if (this.props.onCustomHandleChange) {
          this.props.onCustomHandleChange(tempObj, name)
        }

        // Se è una lookup faccio un controllo sui campi da controllare. Se sono cambiati cambio la chiave a quella lookup, incrementandola nella relativa mappa
        if (target.type === 'select-one') {
          this.lookupFieldsWithFieldsToCheck.forEach ((field: string) => {
            var fieldsToCheck = this.lookupFieldsToCheck.get(field)
            if (fieldsToCheck) {
              for(var i=0;i< fieldsToCheck.length;i++)
              {
                if (fieldsToCheck[i]==name) {
                  let newKey = this.lookupKeys.get(field)
                  if (newKey == undefined) newKey = 0
                  this.lookupKeys.set(field, newKey+1)
                }
              }
            }
          })
        }

        this.setState({
          myObject: tempObj
        });
      }
    }
  }

  // Esce dall'edit e torna alla lista di oggetti (ObjectList)
  returnToList = () => {
    if (this.props.onReturn!=undefined) {
        this.props.onReturn()
    }
  }

  // Gestise il ritorno dal componente per inserire attachments
  // TODO modificare
  onReturnFromAttachmentsController = (returnMessage: string) => {
    //TODO capire se stampare il messaggio da qualche parte
    // Svuoto gli attachments in modo che se li riapro me li ricarica
    //this.setState({myObjectAttachments:[]})
    this.toggleAddAttachments()
  }

  // Mostra il component per aggiungere allegati
  toggleAddAttachments = () => {
    this.setState({addAttachments: !this.state.addAttachments})
  }

  // Mostra il component per aggiungere allegati
  toggleShowAttachments = () => {
    this.setState({showAttachments: !this.state.showAttachments})
  }

  lookupLoadedFieldsToCheck = (fieldName: string, fieldsToCheck: any[]) => {
    // Setto i fields to check nella mappa
    if (!this.lookupFieldsWithFieldsToCheck.includes(fieldName)) this.lookupFieldsWithFieldsToCheck.push(fieldName)
    this.lookupFieldsToCheck.set(fieldName, fieldsToCheck)
  }

  render() {

    var errorMessage = (this.state.errorMessage>'')? 
    (<Alert color="danger">{this.state.errorMessage}</Alert>)
    : undefined

    if (this.state.loading)
    {
      return (
        <Row className={themeGroup()}>
          <Col className={themeCol9()}>
            <i className={themeSpinner()}></i>  Caricamento...  
          </Col>
        </Row>
      )
    }

    if (this.state.updating)
    {
      return (
        <Row className={themeGroup()}>
          <Col className={themeCol9()}>
            <i className={themeSpinner()}></i>   Aggiornamento in corso...  
          </Col>
        </Row>
      )
    }

    else if (this.state.addAttachments) {
      return (
        <EsaedroAttachmentLoader  Resource_ID={this.props.myObjResourceID?this.props.myObjResourceID:0} 
                                  Item_ID={this.props.myObj.Id?this.props.myObj.Id:0}
                                  onReturn={this.onReturnFromAttachmentsController}>
        </EsaedroAttachmentLoader>
      )
    }

    else if (this.state.hasFields)
    {
      this.disableUpdateBtn = false

      // Bool per passaggio veloce da Sticky a no. Potrebbe essere in un parametro o essere tolto in futuro
      let isSticky = true

      let addAttachmentsToggleButton = this.state.addAttachments ? 
                    <Button className={themeBackButton()} 
                        onClick={this.toggleAddAttachments}><i className="fa fa-close"></i>Chiudi Aggiunta Allegati</Button> 
                    : <Button className={themeSaveButton()} 
                        onClick={this.toggleAddAttachments}><i className="fa fa-plus"></i> Aggiungi Allegati</Button>

      let showAttachmentsToggleButton = this.state.myObject.AttachmentCount > 0? 
                    this.state.showAttachments ? 
                      <Button className={themeBackButton()} 
                          onClick={this.toggleShowAttachments}><i className="fa fa-close"></i> Nascondi Allegati</Button> 
                      : <Button className={themeSaveButton()} 
                          onClick={this.toggleShowAttachments}><i className="fa fa-plus"></i> Mostra Allegati</Button>
                      : undefined


      // Mostra gli allegati della risorsa
      let attachments = this.state.showAttachments ?
                    <EsaedroAttachmentsController 
                        Resource_ID={this.props.myObjResourceID?this.props.myObjResourceID:0} 
                        Item_ID={this.props.myObj.Id?this.props.myObj.Id:0} >  
                    </EsaedroAttachmentsController>
                    : undefined

      let updateButton = this.state.myObject.disableEdit ?
                    undefined
                    :   <Button className={themeSaveButton()} 
                                size="lg" disabled={this.disableUpdateBtn} 
                                onClick={this.updateObject}>{this.props.isNew?<i className="fa fa-plus"></i>:<i className="fa fa-save"></i>}</Button>

      // Creo la barra di bottoni Sticky, ovvero che segue lo scroll della pagina
      let sticky = 
        <Sticky>
          {({ style }) => (
            <div style={style}>
              <Row className={themeGroup()}>
                <Col className={themeCol6()}>
                  {updateButton}
                </Col>
                <Col className={themeCol6Right()}>
                  <Button className={themeBackButton()} size="lg" onClick={this.returnToList}><i className="fa fa-close"></i></Button>
                </Col>
              </Row>
            </div>
          )}
        </Sticky>

      let fieldsToRender = this.state.myObjectFields.map((field: ResourceField) => {
        return this.renderField(field);
      })

      let attachmentContent = <Fragment>
        <Row>{showAttachmentsToggleButton}</Row>
        <Row>
          &nbsp;
        </Row>
        <Row>
          {attachments}
        </Row>
        <Row>
          &nbsp;
        </Row>
        <Row>{addAttachmentsToggleButton}</Row>
      </Fragment>

      if (!isSticky) return (        
        <form onSubmit={this.updateObject}>
          <Container>
            <Row>
                <Col>
                  &nbsp;
                </Col>
            </Row>
            <Row className={themeGroup()}>
              <Col className={themeCol6()}>
                {updateButton}
              </Col>
              <Col className={themeCol6Right()}>
                <Button className={themeBackButton()} size="lg" onClick={this.returnToList}><i className="fa fa-close"></i></Button>
              </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            {errorMessage}
            {fieldsToRender}
            {attachmentContent}
          </Container>
        </form>
      )
      else return (
        <Container>
          <Row>
            <Col>
              &nbsp;
            </Col>
          </Row>
          <StickyContainer className="container">
            {sticky}
            <Row>
              &nbsp;
            </Row>
            <div style={{width: "85%", margin: "0 auto", display: "block"}}>
              {errorMessage}
              {fieldsToRender}
              {attachmentContent}
            </div>
          </StickyContainer>
        </Container>
      )
    }
    // Serve davvero?
    else return (
      <Container>
        <Row>
            <Col>
            </Col>
        </Row>
        <Row>
            <Col>
              &nbsp;
            </Col>
        </Row>
        <Row className={themeGroup()}>
          <i className={themeSpinner()}></i>    Caricamento...
        </Row>
      </Container>
    )
    
  }

  // Funzione che si occupa di renderizzare ogni singolo campo in base al tipo e ai suoi parametri
  renderField = (field: ResourceField) => {

    // Qui la lista è filtrata a monte in caso di update, va gestita in caso di insert - TODO capire come gestirla
    if (this.props.isNew && !field.Is_Visible && !field.Is_Key && !field.Is_Nullable) return

    // Questi campi non devono mai essere visibili
    if (field.FieldName == 'dat_obsoleto' || 
        field.FieldName == 'cod_utente_cre' || 
        field.FieldName == 'dat_utente_cre' || 
        field.FieldName == 'cod_utente_mod' || 
        field.FieldName == 'dat_utente_mod') return

    if (this.props.isNew && !field.Is_Visible && (field.Is_Key || field.Is_Nullable)) {
      field.Field_Label = "ERRORE - Campo chiave o non nullabile"
      field.Readonly = true
    }

    // Se è di tipo Object List non devo mostrarlo
    if (field.Reffered_Resource_Type == 1 || field.Is_Decode || field.Is_Identity) return

    // Questi campi vanno sempre ignorati e mai visualizzati
    if (field.FieldName == "ts_update" || field.FieldName == "flg_isdeleted" || field.FieldName == "dat_ultvar") return
  
    // Qui scorro i fixed fields per trovare l'elenco dei campi non editabili
    if (this.props.fixedFields) {
      let i : number
      for (i=0; i<this.props.fixedFields.length; i++) {
        if (field.FieldName == this.props.fixedFields[i].FieldName && this.props.fixedFields[i].Operator == "=") {
          field.Readonly = true
          break
        }
      }
    }

    // Se è sync o siamo in edit ed è chiave il campo deve essere ReadOnly
    if (field.Is_Syncronized || ((field.Is_Key) && !this.props.isNew) || this.state.myObject.disableEdit) field.Readonly = true

    // Se è chiave e non nullabile deve essere obbligatorio
    if (field.Is_Key || !field.Is_Nullable ) field.Required = true

    // Inserisco qui l'eventuale callback
    if (this.props.onCustomRenderField) {
      this.props.onCustomRenderField(this.state.myObject, field)
    }

    var validationError = this.validateField(field)
    // Governa il disable del tasto update
    if (validationError) this.disableUpdateBtn = true


    // Lookup 
    if (field.LookupName|| field.LookupValues)
    {   
      return (
        <Row className={themeGroup()}>
          <Col className={themeCol3()}>
            <label htmlFor={field.FieldName}>{field.Field_Label}</label>   
          </Col>
          <Col className={themeCol4()}>
            <EsaedroLookup 
              name={field.FieldName} 
              value={this.state.myObject[field.FieldName]} 
              fatherObj={this.state.myObject}
              onChange={this.handleChange}  
              lookupName={field.LookupName?field.LookupName:''} 
              lookupValues={field.LookupValues?field.LookupValues:''} 
              displayName={field.Field_Label}
              isDisabled={field.Readonly}
              onFieldsToCheckLoaded={this.lookupLoadedFieldsToCheck}
              key={this.lookupKeys.get(field.FieldName)}>
            </EsaedroLookup>
            {validationError}
          </Col>
        </Row>
      )
    }

    // Controllo se è un pdf e nel caso gli assegno il Field_Type 400
    if (field.Field_Type == 200 && field.ContentType == "pdf") field.Field_Type = 400 
    
    // Checkbox
    switch (field.Field_Type) {
      case 1:
      case 2:
        return (
          <Row className={themeGroup()}>
              <Col className={themeCol3()}>
                <label htmlFor={field.FieldName}>{field.Field_Label}</label>  
              </Col>
              <Col className={themeCol9()}>
                <input type="checkbox" className={themeFormInput()} name={field.FieldName} disabled={field.Readonly} checked={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>
                  {validationError}
              </Col>
          </Row>   
        )

      case 4:
      case 15:
      case 33:
        // Datetime
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="datetime-local" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                 {validationError}
            </Col>
          </Row>
        )
      case 31:
        // Date - Controllare MOMENT
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="date" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                 {validationError}
            </Col>
          </Row>
        )
        case 32:
          // Time - Controllare MOMENT
          return (
            <Row className={themeGroup()}>
              <Col className={themeCol3()}>
                <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
              </Col>
              <Col className={themeCol9()}>
                <input className={themeFormInput()} type="time" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                   {validationError}
              </Col>
            </Row>
          )

      case 400:
        // PDF - Assegnato a monte
        // Creo il component per il PDF
        //return <embed src={`data:application/pdf;base64,${this.state.myObject[field.FieldName]}`}  type="application/pdf" width="100%" height="100%"></embed>
        return ( 
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <EsaedroPDF file={`data:application/pdf;base64,${this.state.myObject[field.FieldName]}`} filename={this.state.myObject.cod_nomefile} />  
              {validationError}
            </Col>
          </Row>
        )

      case 201:
        // Allegato
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <EsaedroAttachment 
                        attachment={this.state.myObject[field.FieldName]} 
                        attachmentFieldName={field.Field_Label} 
                        name={field.FieldName}
                        canLoad={!field.Readonly} 
                        canDelete={!field.Readonly}
                        onChange={this.handleChange}>
              </EsaedroAttachment> 
              {validationError}
            </Col>
          </Row>
        )

        case 100:
        // JSON Generico
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <EsaedroJSONComponent 
                        component={this.state.myObject[field.FieldName]}
                        fieldName={field.FieldName}
                        canEdit={!field.Readonly}
                        onChange={this.handleChange}
                        suggestedKeys={field.CustomProperty}
                        key={field.CustomProperty} >
              </EsaedroJSONComponent> 
              {validationError}
            </Col>
          </Row>
        )

        case 98:
          // Array di dati
          /*if (field.FieldName == "ResourcesViewsFilters")
          {
            return (
             <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              
                 {validationError}
            </Col>
          </Row>
          )
          }
          else if (field.FieldName == "ResourcesViewsFilters")
          {

          }
          else if (field.FieldName == "ResourcesViewsFilters")
          {}*/
          return (
             <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              
                 {validationError}
            </Col>
          </Row>
          )
      
      default:
        return (
          <Row className={themeGroup()}>
            <Col className={themeCol3()}>
              <label htmlFor={field.FieldName}>{field.Field_Label}{field.Required?" *":""}</label>   
            </Col>
            <Col className={themeCol9()}>
              <input className={themeFormInput()} type="text" name={field.FieldName} disabled={field.Readonly} required={field.Required} value={this.state.myObject[field.FieldName]} onChange={this.handleChange}/>    
                 {validationError}
            </Col>
          </Row>
        )
    }
  }

  // Valida i campi e genera i messaggi da mostrare in tempo reale sotto al campo stesso
  validateField = (field: ResourceField) => {
    // TODO Lookup
    // Ritorna null se il campo è valido -> governa il tasto update
    // Come gestire la stringa vuota???
    var valueToCheck = this.state.myObject[field.FieldName]
  
    if (field.Is_Key && valueToCheck!==0 && valueToCheck!==false && valueToCheck===undefined) return (
      <Alert color="warning">
        Questo campo è chiave e dunque obbligatorio
      </Alert>
    ) 
    if (!field.Is_Nullable && valueToCheck!==false && valueToCheck!==0 && valueToCheck===undefined) return (
      <Alert color="warning">
        Questo campo non può essere nullo
      </Alert>
    )

    if (field.Required && valueToCheck!==false  && valueToCheck!==0 && (valueToCheck===undefined || valueToCheck=='')) return (
      <Alert color="warning">
        Questo campo è obbligatorio
      </Alert>
    )

    if (valueToCheck) {
      // Controllo la lunghezza
      if (field.Field_Size > 0 && valueToCheck.length > field.Field_Size) return (
        <Alert color="danger">
          Questo campo supera la lunghezza massima consentita
        </Alert>
      )
      //Se è un numero controllo che ci siano solo cifre
      if ((field.Field_Type == 0 || field.Field_Type == 5 || field.Field_Type == 6 || field.Field_Type == 8 || field.Field_Type == 13 ) && isNaN(valueToCheck)) return (
        <Alert color="danger">
          Questo campo deve essere numerico
        </Alert>
      )
    }
    
    return null
  }

  // In caso di New, crea un oggetto nuovo secondo la lista di proprietà (fields) ricevuta
  createEmptyObject = (): any => {

    // customer ID 
    var objToRet: any = {}
    if (this.state.hasFields)
    {

      objToRet.customer_ID = this.context.userProfile.customer_ID

      this.state.myObjectFields.map((field: ResourceField) => {
        
        switch (field.Field_Type) {
          case 1:
          case 2:
            objToRet[field.FieldName] = field.DefaultValue
                                          ?field.DefaultValue=="1"
                                            ?true
                                            :field.DefaultValue=="0"
                                              ?false
                                              :field.DefaultValue
                                          :false
            break
          
          default:
            objToRet[field.FieldName] = field.DefaultValue?field.DefaultValue:undefined
        }

        // Qui scorro i fixed fields per trovare l'elenco dei campi fixed e settarli
        if (this.props.fixedFields) {
          let i : number
          for (i=0; i<this.props.fixedFields.length; i++) {
            if (field.FieldName == this.props.fixedFields[i].FieldName && this.props.fixedFields[i].Operator == "=") {
              objToRet[field.FieldName] = this.props.fixedFields[i].Value
            }
          }
        }
      })
    }
    return objToRet
  }
}
